"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Common_1 = require("../Common");
var Button_1 = require("../Common/Button");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: inline-block;\n"], ["\n\tdisplay: inline-block;\n"])));
var NavButton = (0, styled_components_1.default)(Button_1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-left: 0 !important;\n\tmargin-right: 2px !important;\n\tpadding: 0 !important;\n\ti {\n\t\tfont-size: 9px !important;\n\t\tline-height: 23px !important;\n\t}\n"], ["\n\tmargin-left: 0 !important;\n\tmargin-right: 2px !important;\n\tpadding: 0 !important;\n\ti {\n\t\tfont-size: 9px !important;\n\t\tline-height: 23px !important;\n\t}\n"])));
var PreviousButton = (0, styled_components_1.default)(NavButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
PreviousButton.displayName = 'PreviousButton';
var NextButton = (0, styled_components_1.default)(NavButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
NextButton.displayName = 'NextButton';
var PageTurnOptions = /** @class */ (function (_super) {
    __extends(PageTurnOptions, _super);
    function PageTurnOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.goToPreviousPage = _this.goToPreviousPage.bind(_this);
        _this.goToNextPage = _this.goToNextPage.bind(_this);
        _this.isDisabled = _this.isDisabled.bind(_this);
        return _this;
    }
    PageTurnOptions.prototype.goToPreviousPage = function () {
        var _a = this.props.pageRange, offset = _a.offset, limit = _a.limit, total = _a.total;
        if (!total) {
            return;
        }
        var newOffset = offset;
        if (offset < limit) {
            var remainder = total % limit;
            if (remainder === 0) {
                newOffset = total - limit;
            }
            else {
                newOffset = total - remainder;
            }
        }
        else {
            newOffset = newOffset - limit;
        }
        this.props.updatePageRange(__assign(__assign({}, this.props.pageRange), { offset: newOffset }));
    };
    PageTurnOptions.prototype.goToNextPage = function () {
        var _a = this.props.pageRange, offset = _a.offset, limit = _a.limit, total = _a.total;
        if (!total) {
            return;
        }
        var newOffset = offset + limit >= total ? 0 : offset + limit;
        this.props.updatePageRange(__assign(__assign({}, this.props.pageRange), { offset: newOffset }));
    };
    PageTurnOptions.prototype.isDisabled = function () {
        return !this.props.pageRange.total || this.props.pageRange.total <= this.props.pageRange.limit;
    };
    PageTurnOptions.prototype.render = function () {
        return (React.createElement(Container, { className: 'tws-page-turn-options-wrapper' },
            React.createElement(PreviousButton, { floating: true, className: 'tws-button-previous-page', size: 'xs', onClick: this.goToPreviousPage, disabled: this.isDisabled() },
                React.createElement("span", { className: 'sr-only' }, "Previous page"),
                React.createElement(Common_1.Icon, { name: 'angle-left' })),
            React.createElement(NextButton, { floating: true, className: 'tws-button-next-page', size: 'xs', onClick: this.goToNextPage, disabled: this.isDisabled() },
                React.createElement("span", { className: 'sr-only' }, "Next page"),
                React.createElement(Common_1.Icon, { name: 'angle-right' }))));
    };
    return PageTurnOptions;
}(React.PureComponent));
exports.default = PageTurnOptions;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
